/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Bi_Authoring_Restricted_DescInputs */



/**
* | output |
* | --- |
* | "Dashboard authoring is now restricted to organisation admins." |
*
* @param {Audit_Details_Bi_Authoring_Restricted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_bi_authoring_restricted_desc = /** @type {((inputs?: Audit_Details_Bi_Authoring_Restricted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Bi_Authoring_Restricted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Erstellen von Dashboards ist jetzt auf Organisations-Admins beschränkt.")
	return /** @type {LocalizedString} */ ("Dashboard authoring is now restricted to organisation admins.")
});